import type { ReactNode } from "react";
export interface LegendItem {
  key: string;
  name: string;
  color: string;
  dashed?: boolean;
}
export interface SeriesLegendProps {
  items: LegendItem[];
  selectedKey?: string;
  onSelect?: (key: string) => void;
  children?: ReactNode;
  className?: string;
}
const Swatch = ({
  color,
  dashed
}: Pick<LegendItem, "color" | "dashed">) => dashed ? <svg width="16" height="8" aria-hidden>
      <line x1="0" y1="4" x2="16" y2="4" stroke={color} strokeWidth="2.5" strokeDasharray="4 3" />
    </svg> : <div className="h-3 w-3 rounded-sm" style={{
  backgroundColor: color
}} />;
export const SeriesLegend = ({
  items,
  selectedKey,
  onSelect,
  children,
  className = ""
}: SeriesLegendProps) => <div className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-xs ${className}`} data-sentry-component="SeriesLegend" data-sentry-source-file="SeriesLegend.tsx">
    {items.map(item => {
    if (!onSelect) {
      return <div key={item.key} className="flex items-center gap-1">
            <Swatch color={item.color} dashed={item.dashed} />
            <span>{item.name}</span>
          </div>;
    }
    const isSelected = item.key === selectedKey;
    return <button type="button" key={item.key} onClick={() => onSelect(item.key)} className={`flex items-center gap-1 transition-opacity ${isSelected ? "opacity-100" : "opacity-40 hover:opacity-100"}`}>
          <Swatch color={item.color} dashed={item.dashed} />
          <span className={`tracking-wide ${isSelected ? "font-semibold" : ""}`}>{item.name}</span>
        </button>;
  })}
    {children}
  </div>;